var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GeneralBarraCarga"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin text-primary",style:({  'font-size': `${_vm.tamano}pt` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }